import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function ProblemSection() {
  return <AnimatedSection className="py-24 bg-navy-900 relative px-4 sm:px-6 lg:px-8" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12" data-id="element-118">
          El problema no es cuánto ganas, sino el{' '}
          <span className="text-gold-400 italic" data-id="element-119">"Excedente Fantasma"</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-120">
          <div className="space-y-6 text-lg text-slate-300" data-id="element-121">
            <p data-id="element-122">
              Son esos{' '}
              <strong className="text-gold-400 font-bold text-xl" data-id="element-123">
                $75 a $150 dólares
              </strong>{' '}
              que técnicamente deberían sobrarte cada mes, pero que terminan
              diluyéndose en micro-decisiones: la suscripción que no usas, el
              café de app, o ese gasto "hormiga" que ni siquiera recuerdas al
              día siguiente.
            </p>
            <p data-id="element-124">
              Esta fuga constante no solo drena tu cuenta; drena tu paz mental.
              Te mantiene en un estado de estancamiento donde cualquier
              imprevisto se siente como una crisis y el retiro parece un sueño
              imposible.
            </p>
          </div>

          <div className="relative" data-id="element-125">
            <div className="absolute inset-0 bg-gold-400/5 rounded-3xl transform rotate-3" data-id="element-126" />
            <div className="relative bg-navy-800 border border-navy-700 p-8 rounded-3xl shadow-2xl" data-id="element-127">
              <div className="flex items-center justify-between mb-6 pb-6 border-b border-navy-700" data-id="element-128">
                <span className="text-slate-400" data-id="element-129">Ingreso Mensual</span>
                <span className="text-white font-medium" data-id="element-130">Estable</span>
              </div>
              <div className="flex items-center justify-between mb-6 pb-6 border-b border-navy-700" data-id="element-131">
                <span className="text-slate-400" data-id="element-132">Gastos Fijos</span>
                <span className="text-white font-medium" data-id="element-133">Cubiertos</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-134">
                <span className="text-gold-400 font-bold" data-id="element-135">
                  Excedente Fantasma
                </span>
                <span className="text-red-400 font-bold" data-id="element-136">-$150/mes</span>
              </div>
              <div className="mt-8 pt-6 border-t border-navy-700 text-center" data-id="element-137">
                <span className="text-sm text-slate-500 uppercase tracking-wider font-semibold" data-id="element-138">
                  Impacto Anual: -$1,800 USD
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-139" />
    </AnimatedSection>;
}